import { createAction } from '@ac/library-utils/dist/redux-utils';

export const clearAllGlobalErrors = createAction(
  '@global/clearAllGlobalErrors'
);
